import { axiosGet } from "@/services/axiosService";
import { useQuery } from "@tanstack/react-query";

export default function useGetBotAttributes(botCustomId: string) {
  return useQuery({
    queryKey: ["getBotAttributes", botCustomId],
    queryFn: async () => {
      const response = await axiosGet(
        `/contact/attributes?botCustomId=${botCustomId}`,
      );
      return response.data;
    },
    enabled: Boolean(botCustomId) && botCustomId !== "all",
    staleTime: Infinity,
  });
}
